<template>
  <div class="home split-screen" :style="{height: `${$store.getters.fullHeight}px`}">
    <div class="color-half">
      <div class="container">
        <p class="page-title">Metals In Aqueous Solutions</p>

        <div class="content">
          <h1>Choose a set of experiments</h1>

          <p>Each experiment uses different metals and solutions. Choose an experiment.</p>

          <div class="btn-row end">
            <router-link to="/" class="btn">Start&nbsp;&rarr;</router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="bigger-half">
      <div class="col-2-grid">
        <router-link to="/solutions/0" class="grid-item">
          <span class="text-contain"><strong>Set One</strong>: Various Solutions</span>
          <span class="beaker-holder">
            <Dunk :hold="true" startBeakerImg="beaker-clear.png" class="left-floater" />
            <Dunk :hold="true" startBeakerImg="beaker-red.png" />
            <Dunk :hold="true" startBeakerImg="beaker-clear.png" class="right-floater" />
          </span>
        </router-link>
        <router-link to="/solutions/1" class="grid-item">
          <span class="text-contain"><strong>Set Two</strong>: Various Solutions</span>
          <span class="beaker-holder">
            <Dunk :hold="true" startBeakerImg="beaker-green.png" class="left-floater" />
            <Dunk :hold="true" startBeakerImg="beaker-clear.png" />
            <Dunk :hold="true" startBeakerImg="beaker-teal.png" class="right-floater" />
          </span>
        </router-link>
        <router-link to="/solutions/2" class="grid-item">
          <span class="text-contain"><strong>Set Three</strong>: Various Solutions</span>
          <span class="beaker-holder">
            <Dunk :hold="true" startBeakerImg="beaker-blue.png" class="left-floater" />
            <Dunk :hold="true" startBeakerImg="beaker-green.png" />
            <Dunk :hold="true" startBeakerImg="beaker-clear.png" class="right-floater" />
          </span>
        </router-link>
        <router-link to="/single-solution/3" class="grid-item">
          <span class="text-contain"><strong>Set Four</strong>: Single Solutions</span>
          <span class="beaker-holder">
            <Dunk :hold="true" startBeakerImg="beaker-clear.png" />
          </span>
        </router-link>
      </div>
    </div>
      
  </div>
</template>

<script>
// @ is an alias to /src
import Dunk from '../components/Dunk'

export default {
  name: 'Choose',
  components:{
    Dunk
  }
}
</script>

<style lang="scss" scope>
  #app{
    min-height: 100vh;
    width: 100%;
  }

  .content{
    text-align: left;
    margin: 3.5rem 0;
    font-size: 1.3rem;

    h1{
      font-size: 2.4rem;
      margin-top: 0;
      font-weight: bold;
    }

    p{
      margin-bottom: 2.5rem;
    }

    h2{
      margin-top: 0rem;
    }

    .btn-row{
      display: flex;
      justify-content: space-between;

      &.end{
        justify-content: flex-end;
      }

      .btn:first-of-type{
        margin-right: 1rem;
      }
    }
  }

  .col-2-grid{
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 25px;
    width: 100%;

    @media screen and (min-width: 767px) {
      grid-template-columns: 1fr 1fr;
    }

    .grid-item{
      text-decoration: none;
      overflow: hidden;
      box-shadow: $shadow;
      grid-gap: 15px;
      box-sizing: border-box;
      

      .text-contain{
        background: $lightgrey;
        width: 100%;
        display: block;
        padding: 10px;
        text-align: center;
        text-decoration: none;
        color: $dark;
        transition: all 250ms;
      }

      &:hover{
        span.text-contain{
          background: $blue;
          color: #fff;
        }
      }

      .beaker-holder{
        position: relative;
        width: 100%;
        display: flex;
        justify-content: center;
      }

      .dunk{
        max-width: 250px;
      }

      .left-floater{
        position: absolute;
        width: 100%;
        left: -125px;
        top: 0;
      }

      .right-floater{
        position: absolute;
        width: 100%;
        right: -125px;
        top: 0;
      }
    }
  }
</style>
